import React from 'react';
import NavBarLeft from '../../navBar/NavBarLeft';
import NavBarTop from '../../navBar/NavBarTop';
import RevenueCardY from './card/RevenueCardY';
import RevenueCardM from './card/RevenueCardM';
import ProjectCardLow from './card/ProjectCardLow';
import ProjectCardTop from './card/ProjectCardTop';
import WeeklyCompareCard from './card/WeeklyCompareCard';
import MadeByBRB from './MadeByBRB';

const Dashboard = () => {
    return (
        <main className='w-full h-screen flex justify-between'>
            <div className='w-2/12 h-full hidden lg:block'>
                <NavBarLeft/>
            </div>
            <div className='flex-1 flex flex-col'>
                <div className='h-16'>
                    <NavBarTop/>
                </div>
                <div className='p-4 h-20 lg:p-8 font-bold text-xl font-color-4 flex justify-between items-center'>
                    <div className='text-xl font-bold'>
                        <h1>Dashboard</h1>
                    </div>
                </div>
                <div className='flex-1 flex flex-col px-4 pb-4 lg:px-8'>
                    <div className='flex-1 grid grid-cols-1 lg:grid-cols-3 gap-4'>
                        <div className='col-span-1 lg:col-span-2 bg-white border rounded-md p-4'>
                            <RevenueCardY/>
                        </div>
                        <div className='col-span-1 bg-white border rounded-md p-4'>
                            <RevenueCardM/>
                        </div>
                        <div className='col-span-1 bg-white border rounded-md p-4'>
                            <ProjectCardTop/>
                        </div>
                        <div className='col-span-1 bg-white border rounded-md p-4'>
                            <ProjectCardLow/>
                        </div>
                        <div className='col-span-1 bg-white border rounded-md p-4'>
                            <WeeklyCompareCard/>
                        </div>
                    </div>
                </div>
                <div className='pb-4'>
                    <MadeByBRB/>
                </div>
            </div>
        </main>
    );
};

export default Dashboard;
